export default __webpack_public_path__ + "static/delovi-91d3eb68ff4de332b682e68441ca465a.jpg";